import React, { useEffect } from 'react'
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { language } from '../../stores/slices/languageSlice'
import { patientApplicationFAF, patientApplicationCPR, setDisplayList, setDisplayListTrue } from '../../stores/slices/patientSearch/patientApplicationListSlice';
import { Eye, File, PlusCircle } from 'react-feather'
import { fetchViewAppDetails, resetAppViewDetails, resetInitialTab } from '../../stores/slices/appViewDetailsSlice';
import { resetApplicationsDocLists } from '../../stores/slices/document/documentListSlice';
import { cancelNavigate } from '../../stores/slices/claimIntake/claimIntakeSlice';
import { getAllSessions } from '../../utilities/API/supertokenServices';
import { getPatientDetails, setAllowCaseCreation } from '../../stores/slices/patientSearch/patientSearchSlice';
import { patientCaseListDetails } from '../../stores/slices/caseManagement/patientCaseListSlice';
import { VIEW_CASE_REDIRECTION_URL } from '../../constant/Constants';
import { generateHashData } from '../../stores/slices/caseManagement/generateHashDataSlice';
import { toast } from 'react-toastify';
import { Modal } from 'antd';
import { updateEmailAPI } from '../../stores/slices/portalUserEmailUpdate/portalUserEmailUpdateSlice';
import validateInput from '../../utilities/validations/validateInput';
import Input from '../input/Input';


function PatientCard({ value }) {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const selectedLanguage = useSelector(language).PatientSearch.patientCard
    const generalConfig = useSelector((state) => state.generalConfigSlice);
    const searchPatient = useSelector((state) => state.patientSearchSlice);
    const sessionData = useSelector((state) => state.sessionSlice)
    const patientAppList = useSelector((state) => state.patientApplicationListSlice);
    const patientCaseListData = useSelector((state)=>state.patientCaseListSlice)
    const createPatientLanguage = useSelector(language).PatientSearch.createPatient;
    const errorMessage = useSelector(language).errorMessage;

    const [allowedEmailDomains, setAllowedEmailDomains] = useState([])
    const [failureSFMsg, setFailureSFMsgs] = useState([])
    const [emailModal, setEmailModal] = useState(false);
    const [updateEmail, setUpdateEmail] = useState({
        email: {
            value: "",
            isValid: true,
        },
    })
    const [viewApplicationList, setViewApplicationList] = useState(false);
    const loginData = useSelector((state) => state.loginSlice)
    const [appList, setAppList] = useState([]);

    useEffect(() => {
        setUpdateEmail({
            email: {
                value: loginData.Email,
                isValid: true,
            },
        });
    }, [])

    const apiCall = async () => {
        let reqBody = {
            Patients: {
                FirstName: searchPatient.patientDetails.firstName.trim(),
                LastName: searchPatient.patientDetails.lastName.trim(),
                DateOfBirth: searchPatient.patientDetails.dob.trim(),
                SocialSecurityNumber: searchPatient.patientDetails.ssn.trim(),
                AlienNumber: searchPatient.patientDetails.alienNumber.trim(),
            },
            Provider: {
                ProviderID: `E-${loginData.value.EIN}`,
                ProviderNPINbr: `E-${loginData.value.EIN}`,
                IsPortalAuthorized: "true",
                IsPaymentAuthorized: "true",
                IsAuthorizedProvider: "true"
            }
        }
            const caseData = await dispatch(patientCaseListDetails({patientid : searchPatient.patientDetails.caseID}))
            dispatch(setAllowCaseCreation(true))
            const arr = []
            if (caseData?.payload?.status == "SUCCESS" && caseData?.payload?.data?.length > 0) {
                caseData?.payload?.data?.map((data) => {
                    arr.push({
                        "program": "Case Management",
                        "status": data?.status || "--",
                        "caseOwner": data?.caseowner || "--",
                        "caseID": data?.caseid || "--",
                        "applicationID": data?.casenumber || "--",
                        "createdDateTime": data?.createddate || "--",
                        "einNumber": data?.einnumber || "--",
                    })
                })
            }

            setAppList([...appList, ...arr])

            dispatch(patientApplicationCPR({ data: reqBody, prgData: 'CPR', patientPartnerID: searchPatient.patientDetails.patientId }))
       
            dispatch(patientApplicationFAF({ data: reqBody, prgData: 'FAF', patientPartnerID: searchPatient.patientDetails.patientId }))

    }

    useEffect(() => {
        // setTimeout(()=>{
        apiCall();
        patientCaseListData.patientCaseList.program != "--" && dispatch(setDisplayListTrue())
        // },5000)
    }, [patientCaseListData.patientCaseList.program])

    const viewList = () => {
        // patientAppList.cprApp
        // patientAppList.fafApp
        let sortList = []
        let listCPR = JSON.stringify(patientAppList.cprApp);
        listCPR = JSON.parse(listCPR);
        let listFAF = JSON.stringify(patientAppList.fafApp);
        listFAF = JSON.parse(listFAF);
        sortList = listCPR.concat(listFAF)
        if(patientCaseListData?.patientCaseList[0]?.program != "" && patientCaseListData?.patientCaseList[0]?.program != "--"){
        let listCASE = JSON.stringify(patientCaseListData.patientCaseList);
        listCASE = JSON.parse(listCASE);
        sortList = sortList.concat(listCASE)
        }
        sortList.sort((data, temp) => new Date(temp.createdDateTime) - new Date(data.createdDateTime));
        if (sortList.length > 0) {
            setViewApplicationList(true);
            setAppList(sortList);

        }

        dispatch(setDisplayList())
    }
    const viewApp = async(tab, appID, Program, data) => {
        if (Program == "Case Management"){
            if(data.einNumber == loginData.value.EIN){
            const hashed = await dispatch(generateHashData({ portalUserId: loginData.value.PortalUserID, patienId: "" }))
            if (hashed?.payload?.HashDetails?.HashValue) {
                const hashData = hashed?.payload?.HashDetails?.HashValue
                window.open(`${VIEW_CASE_REDIRECTION_URL}?recordId=${data.caseID}&token=${hashData}`, '_blank');
            } else {
                if (hashed?.payload?.ResponseDetails?.ResponseCode == "RE006" && hashed?.payload?.ResponseDetails?.AllowedEmailDomains && JSON.parse(hashed?.payload?.ResponseDetails?.AllowedEmailDomains?.length > 0)) {
                    setAllowedEmailDomains(JSON.parse(hashed?.payload?.ResponseDetails?.AllowedEmailDomains))
                    setFailureSFMsgs(hashed?.payload?.ResponseDetails?.message)
                    setEmailModal(true)
                } else {
                    toast.error("Something went wrong, Please try again in a few minutes");
                }
            }
        }else{
            toast.warn("You don't have access to view this case")
        }
        }else {
            dispatch(resetAppViewDetails());
            dispatch(resetApplicationsDocLists());
            dispatch(resetInitialTab(tab));
            dispatch(fetchViewAppDetails({ applicationID: appID, prgData: Program }))
            dispatch(getPatientDetails({ memberId: data.patientID, prgData: Program }))
            dispatch(cancelNavigate(false))
            return navigate('/applications/Details')
        }
    }

    patientAppList.displayList && viewList()

    const updatePortalUserMail = () => {
        if (updateEmail.email.value != '' && updateEmail.email.isValid) {
            let data = {
                newEmail: updateEmail.email.value,
                existingEmail: loginData.value.EmailAddress,
            }
            dispatch(
                updateEmailAPI({ email: data, portalID: loginData.value.PortalUserID })
            )
        } else {
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
        }
    }

    const emailOnChange = (e, fieldValidation) => {

        let inputValue = e.target.value;
        let inputName = e.target.name;

        let inputValidate = validateInput(inputValue, fieldValidation);
        setUpdateEmail((prevState) => ({
            ...prevState,
            [inputName]: {
                value: inputValidate.value,
                isValid: inputValidate.isValid
            }
        }))

    }


    return (
        ((searchPatient.displayPatientCard && viewApplicationList) || appList.length > 0) ?
            <React.Fragment>
                <div className="g-col-12 mt-6">
                    <div className="intro-y overflow-auto overflow-lg-visible mt-8 mt-sm-0">
                        <table className="table table-report mt-sm-2">
                            <thead>
                                <tr>
                                    <th className="text-center text-nowrap display">{selectedLanguage.program}</th>
                                    <th className="text-center text-nowrap">{selectedLanguage.applicationID}</th>
                                    <th className="text-center text-nowrap">{selectedLanguage.status}</th>
                                    <th className="text-center text-nowrap">{selectedLanguage.actions}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appList.map((data) => {
                                    return (
                                        <tr className="intro-x">
                                            <td className='display text-center'>
                                                <p className="fw-medium text-nowrap">{data?.program == "CPR" ? "TotalAssist" : data?.program }</p>
                                            </td>
                                            <td className="text-center">{data?.applicationID}</td>
                                            <td className="w-40">
                                                <div class={`py-1 px-5 g-col-5 rounded-pill fs-xs ${(data?.status == 'Denied' || (data?.program == "Case Management" && data?.status == 'Closed')) ? `bg-theme-6` : data?.status == 'Pending' ? `bg-yellow` : (data?.status == 'Approved' || data?.status == 'In Progress' || data?.status == 'InProgress' || data?.status == 'Attempted' )? `bg-theme-9` : `bg-default`} text-white fw-medium text-center`}>{data?.status} </div>
                                            </td>
                                            <td className="table-report__action w-30">
                                                <div className="d-flex justify-content-center align-items-center p-3">
                                                    <a className="d-flex align-items-center me-3 cursor-pointer" onClick={() => { viewApp(1, data?.applicationID, data?.program, data) }}><div className='h-15 p-2'> <Eye /></div>{selectedLanguage.view} </a>
                                                    {data?.action?.submitClaim && <a className="d-flex align-items-center me-3 cursor-pointer" onClick={() => { viewApp(7, data?.applicationID, data?.program, data) }}><div className='h-15 p-2'> <PlusCircle /></div>Submit Claim </a>}
                                                    {data?.action?.uploadDoc && <a className="d-flex align-items-center me-3 cursor-pointer" onClick={() => { viewApp(5, data?.applicationID, data?.program, data) }}><div className='h-15 p-2'> <File /></div>Upload Document </a>}

                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div>
                </div>
                <Modal
                    title={failureSFMsg != undefined ? failureSFMsg : ""}
                    open={emailModal}
                    onOk={() => { updatePortalUserMail() }}
                    onCancel={() => {
                        setUpdateEmail({
                            email: {
                                value: loginData.Email,
                                isValid: true,
                            },
                        });
                        setEmailModal(false);
                    }}
                    width={800}
                    cancelText="Cancel"
                    maskClosable={true}
                    closeIcon={false}
                    okText="Save"
                    centered
                >
                    <div className="mb-5">
                        <ul>
                            {typeof allowedEmailDomains != "undefined" && allowedEmailDomains.length > 0 && allowedEmailDomains.map((data) => {
                                return (
                                    <li className="list-disc ms-5"> {data} </li>
                                )
                            })}
                        </ul>
                    </div>
                    <Input
                        id="email"
                        type="text"
                        name="email"
                        label={createPatientLanguage.email}
                        value={updateEmail.email.value}
                        isValid={updateEmail.email.isValid}
                        errorMsg={errorMessage.inputErrorMessage}
                        onChange={(e) => emailOnChange(e, "email")}
                        maxLength="100"
                    />
                </Modal>
            </React.Fragment> :
            (!value && <div className='intro-y box p-8'>No applications found!</div>)
    )
}

export default PatientCard